import {Dispatch, SetStateAction, useState} from 'react'
import { MealDate } from '../../model/MealDate'
import { CustomerMeal } from '../../model/CustomerMeal'
import {Divider, message, Switch, Tooltip} from 'antd'
import { ProviderValue, useAxios } from '../../config/axios-config'
import dayjs, { Dayjs } from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { MealDateRequestDTO } from '../../model/MealDateRequestDTO'
import React from 'react'
import { Customer } from '../../model/Customer'
import { isMobile } from 'react-device-detect';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {useAuth0} from "@auth0/auth0-react";
import {Meal} from "../../model/Meal";

dayjs.extend(isoWeek)
export const MealDateComponent : React.FC<{
    customer : Customer,
    customerMeal : CustomerMeal, 
    pickedDate : Dayjs,
    setTotalChanges : Dispatch<SetStateAction<boolean>>,
    setBillingTotal : Dispatch<SetStateAction<number>>,
    setBillingTotalAmount : Dispatch<SetStateAction<number>>
}> = (props) => {

    const {
        user,
    } = useAuth0();

    const axiosInstance = useAxios() as ProviderValue
    const {customer, customerMeal, pickedDate, setTotalChanges, setBillingTotal, setBillingTotalAmount} = props
    const [loading, setLoading] = useState<boolean>(false)
    const weekends = [6,7]
    const [messageApi, contextHolder] = message.useMessage();
    const handleReplace = (index : number, replacement : string, mealDays : string) : string => {
        return mealDays.substring(0, index) + replacement + mealDays.substring(index + replacement.length);
    }

    const handleSaveOrDelete = async (e : boolean, i : number) => {
        let description = `${e ? 'Naliczono' : 'Odliczono'} posiłek ${customerMeal.meal.details} w dniu ${i < 9 ? `0${i}` : `${i}`}.${pickedDate.month()+1 < 9 ? `0${pickedDate.month()+1}` : `${pickedDate.month()+1}`}`
        setLoading(true)
        let previousMealDays = customerMeal.recentMealDate!.mealdays
        let previousTotal = customerMeal.recentMealDate!.total
        let previousTotalAmount = customerMeal.recentMealDate!.totalAmount
        let previousBillingTotal = customer.billings.find(billing => dayjs(billing.datePeriod).month()+1 === pickedDate.month()+1)?.billingTotal
        let previousBillingTotalAmount = customer.billings.find(billing => dayjs(billing.datePeriod).month()+1 === pickedDate.month()+1)?.billingTotalAmount
        customerMeal.recentMealDate!.mealdays = handleReplace(i, e ? "1" : "0", customerMeal.recentMealDate!.mealdays)
        customerMeal.recentMealDate!.total = previousTotal + ( e ? 1 : -1)
        let currentBilling = customer.billings.find(billing => dayjs(billing.datePeriod).month()+1 === pickedDate.month()+1)
        currentBilling!.billingTotal = previousBillingTotal! + ( e ? 1 : -1)
        customerMeal.recentMealDate!.totalAmount = previousTotalAmount + ( e ? customerMeal.meal.amount : -customerMeal.meal.amount)
        currentBilling!.billingTotalAmount = previousBillingTotalAmount! + ( e ? customerMeal.meal.amount : -customerMeal.meal.amount)
        let tempMealDateRequestDTO = new MealDateRequestDTO(customerMeal.recentMealDate!, currentBilling, i, description, customerMeal.meal.mealid)
        await axiosInstance.post<MealDate>(`/mealdates/secure/save`, tempMealDateRequestDTO).then((response) => {
            setBillingTotal(prev => prev + + ( e ? 1 : -1))
            setBillingTotalAmount(prev => prev + ( e ? customerMeal.meal.amount : -customerMeal.meal.amount))
            setTotalChanges(prev => !prev)
          }).catch((e) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
            customerMeal.recentMealDate!.mealdays = previousMealDays
            customerMeal.recentMealDate!.total = previousTotal
            customerMeal.recentMealDate!.totalAmount = previousTotalAmount
            currentBilling!.billingTotal = previousBillingTotal!
            currentBilling!.billingTotalAmount = previousBillingTotalAmount!
            if (e.response?.data?.message !== undefined
                && e.response?.data?.message === 'Update made after deadline') {
                messageApi.open({
                    type: 'error',
                    content: 'Przekroczono godzinę, do której możliwe było zgłoszenie posiłku na ten dzień.',
                });
            }
        })  
        setLoading(false)
    }

    const handleSwitchLabels = (i : number) : string => {
        if (i < 1 || i > pickedDate.daysInMonth()) {
            return "--"
        } else if (i < 10) {
            return `0${i}`
        } else {
            return `${i}`
        }
    }

    const handleAmountAndCost = () => {
        let total = customerMeal.recentMealDate!.total
        let totalAmount = customerMeal.recentMealDate!.totalAmount
        return isMobile ? `${total} szt.` : `${total} szt. (${totalAmount} zł)`
    }

    const handleDisabledDate = (i : number, meal : Meal) : boolean => {
        if (user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT) && !meal.editableForParent) {
            return true
        }
        var preventMinutes = meal.preventMinutes
        let weekendCheck = (i < 1 || i > pickedDate.daysInMonth()) || weekends.includes(dayjs(`${pickedDate.year()}-${pickedDate.month()+1}-${i<10 ? `0${i}` : i}`).isoWeekday())

        let defaultDate = dayjs().set('date', i).set('month',pickedDate.month()).locale('pl').set('hour', 7).set('minute', 0).set('second', 0).set('millisecond', 0)
        let date = defaultDate.add(preventMinutes, 'minutes')
        let isTooLate = dayjs().locale('pl').isAfter(date)

        if (user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT)) {
            return weekendCheck || isTooLate
        } else {
            return weekendCheck
        }
    }

    const highlightDayIndicator = (i : number) => {
        return i === dayjs().get('date') && pickedDate.month()+1 === dayjs().month()+1
    }

    const mappedMealDays = () : any[] => {
        let columns : any[] = []
        let daysBefore = pickedDate.isoWeekday()-1
        let daysAfter = 7 - pickedDate.isoWeekday()
        
        if (customerMeal.meal.singlePayment) {
            columns.push(
                <React.Fragment key={1}>
                    <Switch
                        checkedChildren={'Nalicz w tym miesiącu'} 
                        unCheckedChildren={'Nie naliczaj w tym miesiącu'}
                        checked={customerMeal.recentMealDate!.mealdays.charAt(1) === "1"}
                        onClick={(e) => handleSaveOrDelete(e, 1)}
                        loading={loading}
                        disabled={user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT)}
                    />
                </React.Fragment>
            )
        } else {
           for (let i = pickedDate.get('date') - daysBefore; i <= pickedDate.get('date') + daysAfter; i++) {
            columns.push(
                <React.Fragment key={i}>
                    {isMobile ?
                    <></>
                    :
                    <>
                    {highlightDayIndicator(i) ? <Divider type='vertical' variant="dotted" style={{ borderColor: '#7cb305', marginLeft: '-2px'}}/>:<></>}
                    </>
                    }
                    <Switch
                        size = {highlightDayIndicator(i) ? undefined : "small"}
                        checkedChildren={handleSwitchLabels(i)} 
                        unCheckedChildren={handleSwitchLabels(i)}
                        checked={customerMeal.recentMealDate!.mealdays.charAt(i) === "1"}
                        disabled={handleDisabledDate(i, customerMeal.meal)}
                        onClick={(e) => handleSaveOrDelete(e, i)}
                        loading={loading}
                    />
                    {isMobile ?
                    <></>
                    :
                    <>
                    {highlightDayIndicator(i) ? <Divider type='vertical' variant="dotted" style={{ borderColor: '#7cb305', marginLeft: '-4px'}}/>:<></>}
                    </>
                    }
                    
                </React.Fragment>
            )
           } 
        }
        
        return columns
    }

    return (
        <>
        {contextHolder}
        {isMobile ?
        <tr >
        <td className='customTextColor px-3 text-center'>
        {`${customerMeal.meal.details} | ${handleAmountAndCost()} `}{dayjs(customerMeal.customermealEnd).month() === dayjs().month() 
                    && dayjs().month() === pickedDate.month()  ? 
                    <Tooltip title="Posiłek u tego rodzica został wcześniej zdezaktywowany. Od następnego miesiąca nie będzie połączony z rodzicem" 
                        arrow placement="right">
                        <ErrorOutlineIcon fontSize="small" sx={{ color: 'orange' }}/>
                    </Tooltip>
                    :
                    ""
                }<br></br>
        {mappedMealDays()}
        </td>
    </tr>
        :
        <tr>
            <td><Divider type="vertical" /></td>
            <td className='customTextColor px-3'>
                {`${customerMeal.meal.details} `}
                {dayjs(customerMeal.customermealEnd).month() === dayjs().month() && dayjs().month() === pickedDate.month() ? 
                    <Tooltip title="Posiłek u tego rodzica został wcześniej zdezaktywowany. Od następnego miesiąca nie będzie połączony z rodzicem" 
                        arrow placement="right">
                        <ErrorOutlineIcon fontSize="small" sx={{ color: 'orange' }}/>
                    </Tooltip>
                    :
                    ""
                }
                {user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT) && !customerMeal.meal.editableForParent ?
                    <Tooltip title="Ten posiłek może aktualizować tylko właściciel placówki."
                             arrow placement="right">
                        <ErrorOutlineIcon fontSize="small" color={"primary"}/>
                    </Tooltip>
                    :
                    ""
                }
            </td>
            <td><Divider type="vertical" /></td>
            <td className='customTextColor px-3'>
                {handleAmountAndCost()}
            </td>
            <td><Divider type="vertical" /></td>
            <td className='px-3 text-center'>
                {mappedMealDays()}
            </td>
            <td><Divider type="vertical" /></td>
        </tr>
        }
        </>
            
    )
}